<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        
        <b-card header-tag="header" footer-tag="footer">  
             <template v-slot:header>
                <div class="headerLeft" style="display: flex">
                    <router-link class="btn hl-element btn-success" variant="success" tag="a" :to="'/User/AddAuth'"> 
                       {{$t('general.add')}}
                    </router-link>
                </div>
            </template>
                 
            <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
                                  
            <b-table-simple v-else hover responsive>
                <b-th> {{$t('user.list.authCode')}} </b-th>
                <b-th> {{$t('user.list.authName')}} </b-th>
                <b-th> {{$t('user.list.actions')}} </b-th>

                <b-tbody >
                    <b-tr  v-for="item in list" :key="item.id" @dblclick="goDetail(item)" :style="'color:'+item.fontColor+'; background:'+item.backColor" > <!-- v-b-popover.hover="popoverConfig(item.note)" -->
                        <b-td> {{item.authority_code}} </b-td>
                        <b-td> {{item.authority_name}} </b-td>
                        <b-td> 
                            <b-dropdown variant="default">
                                <template slot="button-content"> <b-icon title="İşlemler" icon="three-dots"  scale="1.25" shift-v="1.25" aria-hidden="true" /> </template>
                                <b-dropdown-item @click="goMenus(item)"> {{$t('user.list.setMenusAction')}} </b-dropdown-item>
                                <b-dropdown-item @click="goCasbin(item)"> {{$t('user.list.setAuthsAction')}} </b-dropdown-item>
                                <b-dropdown-item @click="openModal(true, 'delete', item)"> {{$t('user.list.deleteAuthsAction')}} </b-dropdown-item>
                            </b-dropdown>
                        </b-td>

                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" :onComplete="complete" />
    
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Table from "@/components/Table"
    import i18n from '@/plugins/i18n';
    import Modals from "./modals/";

    let breadCrumb = [
        { label: i18n.t('pages.user.auths'), url: "/User/Auth" },
        { label: i18n.t('pages.user.authList'), url: "/User/Auth" },
    ]

    export default {
        name: 'AuthList',
         created: async function(){
            await this.$store.dispatch('authgrp_list')
        },
        computed:{
            fetchData(){
                this.$store.dispatch('authgrp_list')
            },
            message(){
                return this.$store.getters.getUserStatus
            },
            loading(){
                return this.$store.getters.getLoading
            },
            list(){
                return this.$store.getters.getAuth
            },
        },
        data: function(){
            return{
                breadCrumb, modalOpen: false,
                modalProps: {}, currentForm:"Auth", modalName: "", dismissCountDown: 0
            }
        },
        components:{
            BreadCrumb, Table, Modals
        },
        methods:{
            goDetail(item){
                this.$router.push( { path: '/User/Auth/'+item.id+'/edit' })
            },
            goCasbin(item){
                this.$router.push( { path: '/User/Auth/'+item.authority_code+'/Casbin' })
            },
            goMenus(item){
                this.$router.push( { path: '/User/Auth/'+item.authority_code+'/Menus' })
            },
            complete(){
                this.dismissCountDown = 5
                this.$store.dispatch('authgrp_list')
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            },
           
            actionEvent: async function(key, data){
                switch(key){
                    case 'delete':
                        this.openModal(true, 'delete', data)
                        break;
                }
            },
            openModal: function(state, modal, props){
                this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Users/AuthList.vue